import { Box } from '@mui/material';
import { ReactNode } from 'react';
import {
  MOTION_DURATION,
  MOTION_EASING,
  stepEnterKeyframes,
  usePrefersReducedMotion,
} from './motion';

interface StepTransitionProps {
  children: ReactNode;
}

// Signature view transition for the wizard. Parent re-keys this on the route
// path (`key={location.pathname}`), which remounts the wrapper and re-fires
// the entrance keyframe on every step change — turning the hard `<Outlet />`
// cut into a continuous fade-up.
//
// Layout contract: WizardShell's scroll container stretches its first child to
// fill the viewport (`& > *:first-of-type { flex:1; minHeight:100% }`) so each
// page's bottom-anchored StepNav (`mt:auto`) pins to the footer. This wrapper
// is now that first child, so it must (a) accept the stretch itself and (b)
// forward it to the page inside — hence the column flex + the inner
// `*:first-of-type` rule. Without that, every step's action bar would float up
// to sit directly under its content.
export const StepTransition = ({
  children,
}: StepTransitionProps): JSX.Element => {
  const reduced = usePrefersReducedMotion();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: '100%',
        '& > *:first-of-type': { flex: 1 },
        animation: reduced
          ? 'none'
          : `${stepEnterKeyframes} ${MOTION_DURATION.state}ms ${MOTION_EASING.standard} both`,
      }}
    >
      {children}
    </Box>
  );
};
